import { AuxiliumComponent } from "../auxilium-component";

export default class TextElement extends AuxiliumComponent {
	static observable = ["variation", "size", "width", "icon", "icon-colour", "icon-size"];

	parsedCallback() {
		if (this.variation === "vrm") {
			const vrm = this.textContent.trim();

			if (vrm.length === 7 && !vrm.includes(" ")) {
				this.textContent = vrm.slice(0, 4) + " " + vrm.slice(4);
			}
		}

		if (this.icon) {
			const container = document.createElementWithContents("div", this.childNodes, {
				className: "h-align gap-sm"
			});

			container.prepend(document.createElementWithContents("chip-icon", null, {
				icon: this.icon,
				size: this.iconSize,
				colour: this.iconColour
			}));

			this.appendChild(container);
		}
	}
}
